import React from 'react'
import './CoperateContent.scss'

import coperatePic from '../../assets/Pictures/Corperate.png'

export default function CoperateContent() {
  return (
    <div className='coperateContent'>
      <div className="container">
        <div className="row">
          <div className="right">
            <h1 className="coperateContentTitle">
              ABOUT US
            </h1>
            <h2 className="coperateContentSubtitle">
              We are Engineering, Consultant and International Trading companies that operate in the sector of, Steel products, Construction,
              . Our companies activity mainly in Turkey and Oman. Vigor Global Energy company “VGE” located in Istanbul,  Turkey and Global Energy Investment company “GEI” located in Muscat, Oman.
              <br />
              <br />
              Our companies in Steel sector is official representative of the Kavir Steel Complex (one of the largest producers of steel products in the Middle East) in Turkey,Oman and African countries. we work close cooperation with the leading manufacturing and construction companies in Turkey,‘ Oman and another countries for export high-quality products of Iron and Steel such as wire rod, steel ingot and steel rebar with special grade and European certificates to several factories used as raw material.
              <br />
              <br />
              {/* Global Energy Investment company in MSW plant, recycling and waste to power plant sector, work close cooperation with Dordtech Circular Energy Solutions ( one of the leading company in this sector ). We generate environmentally sustainable energy from waste by turning plastic waste into fuel and converting waste into combustible gases with profitable technology . */}
            </h2>
          </div>
          <div className="left">
            <img src={coperatePic} alt="coperatePic" />
          </div>
        </div>
      </div>
    </div>
  )
}
